import { stripeTeamPlanId, stripeSoloPlanId } from "../util/environment_utils"
import {
    PRICE_INDIVIDUAL,
    PRICE_USER_PER_MONTH,
} from "../common/constants/app_consts"

// check to see if user has entered a valid name (not a blank string or number)
// this regex checks for input that doesn't start and end with a letter, including just a single letter. It will also accept hypenated names and spaces between names
// Good: "Cory West-Forbes"
// Good "Aron Racho"
// Bad: "Cory! West-Forbes"
// Bad: "           Cory"
// Bad: "123"
// Bad: "----Cory West-Forbes"

export function cardHolderNameIsValid(inputName) {
    return /^[a-zA-Z]([\w -]*[a-zA-Z])?$/gm.test(inputName.trim())
}

export function countrySelectorMeta() {
    return [
        { region: "USA", name: "American Samoa" },
        { region: "SA", name: "Argentina" },
        { region: "AUS", name: "Australia" },
        { region: "Europe", name: "Austria" },
        { region: "AS", name: "Bangladesh" },
        { region: "Europe", name: "Belgium" },
        { region: "Europe", name: "British Virgin Islands" },
        { region: "AS", name: "Cambodia" },
        { region: "USA", name: "Canada" },
        { region: "AUS", name: "China" },
        { region: "AUS", name: "Christmas Island" },
        { region: "Europe", name: "Denmark" },
        { region: "Europe", name: "Egypt" },
        { region: "AUS", name: "Fiji" },
        { region: "Europe", name: "Finland" },
        { region: "Europe", name: "France" },
        { region: "Europe", name: "French Polynesia" },
        { region: "Europe", name: "Germany" },
        { region: "Europe", name: "Greece" },
        { region: "UK", name: "Guernsey" },
        { region: "UK", name: "Hong Kong" },
        { region: "Europe", name: "Hungary" },
        { region: "Europe", name: "Iceland" },
        { region: "Europe", name: "India" },
        { region: "Europe", name: "Indonesia" },
        { region: "UK", name: "Ireland" },
        { region: "UK", name: "Isle of Man" },
        { region: "Europe", name: "Israel" },
        { region: "Europe", name: "Italy" },
        { region: "USA", name: "Japan" },
        { region: "UK", name: "Jersey" },
        { region: "Europe", name: "Liechtenstein" },
        { region: "Europe", name: "Luxembourg" },
        { region: "UK", name: "Macau" },
        { region: "UK", name: "Malaysia" },
        { region: "UK", name: "Malta" },
        { region: "USA", name: "Mexico" },
        { region: "USA", name: "Micronesia" },
        { region: "Europe", name: "Monaco" },
        { region: "Europe", name: "Mongolia" },
        { region: "AUS", name: "Nauru" },
        { region: "Europe", name: "Nepal" },
        { region: "Europe", name: "Netherlands" },
        { region: "Europe", name: "Netherlands Antilles" },
        { region: "Europe", name: "New Caledonia" },
        { region: "AUS", name: "New Zealand" },
        { region: "AUS", name: "Norfolk Island" },
        { region: "Europe", name: "Norway" },
        { region: "Europe", name: "Pakistan" },
        { region: "AUS", name: "Papua New Guinea" },
        { region: "USA", name: "Philippines" },
        { region: "Europe", name: "Poland" },
        { region: "Europe", name: "Portugal" },
        { region: "UK", name: "Qatar" },
        { region: "UK", name: "Singapore" },
        { region: "AUS", name: "Solomon Islands" },
        { region: "Europe", name: "South Africa" },
        { region: "Europe", name: "South Korea" },
        { region: "Europe", name: "Spain" },
        { region: "Europe", name: "Sweden" },
        { region: "Europe", name: "Switzerland" },
        { region: "USA", name: "Taiwan" },
        { region: "USA", name: "Thailand" },
        { region: "Europe", name: "Turkey" },
        { region: "UK", name: "United Kingdom" },
        { region: "USA", name: "United States" },
        { region: "AUS", name: "Vanuatu" },
        { region: "Europe", name: "Vatican City" },
        { region: "Europe", name: "Vietnam" },
    ]
}

const BILLING_SETTINGS_TEAM = "Team Standard"
const BILLING_SETTINGS_SOLO = "Solo Standard"
const teamPlanId = stripeTeamPlanId
const soloPlanId = stripeSoloPlanId

export const createUserPlan = plan =>
    plan === soloPlanId
        ? { planName: "Solo", price: PRICE_INDIVIDUAL, period: "Monthly" }
        : { planName: "Team", price: PRICE_USER_PER_MONTH, period: "Monthly" }

export const createPlanTextMeta = customer => {
    if (customer.stripePlan === teamPlanId) {
        return {
            name: BILLING_SETTINGS_TEAM,
            price: PRICE_USER_PER_MONTH,
            period: "month",
            user: "user",
        }
    } else if (customer.stripePlan === soloPlanId) {
        return {
            name: BILLING_SETTINGS_SOLO,
            price: PRICE_INDIVIDUAL,
            period: "month",
            user: "user",
        }
    } else {
        return null
    }
}

export const changePage = (history, page) => {
    history.push(page)
}

export const formatStripeDollarAmount = amount => {
    const dollars = amount / 100
    return dollars.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
    })
}

export const calculateTotalTeamPayment = (price, members) => price * members

export const calculateNumberofTeamMembers = teamMembers => {
    return teamMembers ? Object.keys(teamMembers).length : 0
}



// WEBPACK FOOTER //
// ./src/util/billing_info_utils.js